import { Component, ElementRef, OnDestroy, EventEmitter, OnInit, ViewChild, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from '../../../core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { LogoContentService } from '../../../core/routing/services/asset-library/logo-content.service';
import { StoreLogoService } from '../../../core/routing/services/asset-library/store-logo.service';
import { GlobalConstants } from './../../../common/constants/global.constant';
import { RouterConstants } from './../../../core/routing/constants/app-paths.constant';
import { LogoContent, LogoContentConfiguration, CreateLogoContentResponse, LogoContentGroupPage, LogoContentViewModel } from './interfaces/logo-content.i';
import { CreateStoreLogoResponse, GetStoreLogoByUserResponse, StoreLogoConfiguration, StoreLogoViewModel } from './interfaces/store-logo.i';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../environments/environment';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileRequest, ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { User } from '../../account/login/_models/user.model';
import { AppGlobal } from '../../../core/state/app-global';
import { Utils } from '../../../common/utils/utils';
import { SendToStoreService } from '../../../core/routing/services/asset-library/send-to-store.service';
import { LanguageConstants } from '../../header/constants/lang.consts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageComponent } from '../page/page.component';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CreateDeviceWallpaperResponse, DeviceWallpaper, DeviceWallpaperViewModel } from './interfaces/device-wallpaper';

@Component({
  selector: 'iposcen-logo-content',
  templateUrl: './logo-content.component.html',
  styleUrls: ['./logo-content.component.scss']
})
export class LogoContentComponent implements OnInit, OnDestroy {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('showModal') showModal: ElementRef;
  @ViewChild('applyModal') applyModal: ElementRef;
  @ViewChild('deleteStoreLogoModal') deleteStoreLogoModal: ElementRef;
  @ViewChild('sendToAccountModal') sendToAccountModal: ElementRef;
  @ViewChild('page1') page1: PageComponent;
  @ViewChild('page2') page2: PageComponent;
  @ViewChild('page3') page3: PageComponent;
  @Input() deviceStoreLogoOtherData: boolean;
  @Input() setIposliteEnabled: boolean;
  @Output() readonly deviceStoreLogoId = new EventEmitter<any>();
  @Output() readonly deviceLogoContentId = new EventEmitter<any>();
  @Output() readonly logoContentLength = new EventEmitter<any>();
  whichPageDelete
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  getLengthDeviceLogo = 0
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailHqUser = GlobalConstants.RETAIL_HQ_USER;
  regionalHqUser = GlobalConstants.REGIONALHQ;
  lockContentText = GlobalConstants.CONTENT_LOCKED;
  isStoreUser: boolean;
  configurations: LogoContentConfiguration[];
  // storeLogos: StoreLogoViewModel[];
  defaultStoreLogos: StoreLogoViewModel[] = [];
  otherStoreLogos: StoreLogoViewModel[] = [];
  deviceWallPaperContent:DeviceWallpaperViewModel[] = [];
  storelogos: StoreLogoViewModel[];
  tabIndex = 0;
  allLogoContentGroups: LogoContent[];
  displayLogoContentGroups = [];
  selectedFiles: FileList;
  sortValue = GlobalConstants.CREATED_DATE;
  storeLogoSortValue = GlobalConstants.UPLOAD_DATE;
  logoContentData: LogoContent;
  // TODO create object
  logoCGToDelete: string;
  logoCGToDeleteName: string;
  logoToDelete: string;
  logoToDeleteName: string;
  placementWithoutLogo: string;
  placementWithLogo: string;
  direction: string;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  color = '#ffffff';
  contentGrpData: any;
  pageType = GlobalConstants.LOGO_CONTENT_GROUP;
  LCGlayout = 1;
  logoDeleteButton = GlobalConstants.LOGO;
  logoContentDeleteButton = GlobalConstants.CONTENT_GROUP;
  pages: any; // update the no of pages for edit.
  mediaObjects: any[] = [];
  editCheck: boolean;
  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;
  isDisabled: boolean;
  sendNameToStore: string;
  sendLogoImageName: string;
  sendLogoImageButtonText: string;
  storeOtherLogoContentIdInfo: string;
  sendOtherLogoNameToStore: string;
  sendButtonText: string;
  isSendToStore = false;
  isDefaultStoreSendToStore = false;
  isOtherStoreSendToStore = false;
  storeDefaultLogoContentIdInfo: string;
  pushToDevice: boolean;
  details: string = ' Details';
  clickable = false; // This is to enable tabs click only after clicking on Save & Proceed.TODO: will remove this later.
  // TODO - Sandeep to check with neeraj for page n pagesize
  showLogContentName: string;// To Show logocontentname as tab title.
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  pageGrpForm: any;
  presentPage: string;
  profile_page: string = GlobalConstants.PROFILE;
  assets_page: string = GlobalConstants.ASSET_LIBRARY;
  device_page: string = GlobalConstants.DEVICE_STORE_LOGO;
  buttonName: string;
  showDevice = false;
  applyDevice = false;
  profileData: string;
  isNavigated: boolean = false;
  logoContentIdInfo: string;
  retailHQUser: string;
  isRetailerUser: boolean;
  newLogoContentTitle: string = $localize`:@@logo-content.tab-pane.new-logo-content-group:NEW LOGO CONTENT GROUP`;
  selectLogoContentTooltip: string = $localize`:@@logo-content.tab-pane.select-logo-content-group:Select a logo to use a Logo Content Group`;
  YES: string = GlobalConstants.YES;
  NO: string = GlobalConstants.NO;
  isRemoveEnabled: boolean;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  addToPackageDisabled = GlobalConstants.ADD_TO_PACKAGE_DISABLED;
  deleteTooltipLabel = GlobalConstants.DELETE;
  editTooltipLabel = GlobalConstants.EDIT;
  sendToStoreTooltipLabel = GlobalConstants.OPTIONAL_TOOLTIP;
  createdDateVal = GlobalConstants.CREATED_DATE;
  groupNameVal = GlobalConstants.GROUP_NAME;
  isPage3Created: boolean;
  isImgVideoSizeInfoEnabled: boolean;
  logoContentText = GlobalConstants.STORE_LOGO_HEADER_TEXT;
  logoContentGroupLabel = GlobalConstants.LOGO_CONTENT_GROUP_TEXT;
  uploadDateOption = GlobalConstants.UPLOAD_DATE;
  fileNameOption = GlobalConstants.FILE_NAME;
  uploadImageCheckBtn: boolean;
  selctedContGrpsForProfile: any = {
    contentGrps: []
  };
  profileDataSet: ProfileRequest;
  profileLogoContentData: any = [];
  changePlacement: boolean;
  pageError = new Map([[1, false], [2, false], [3, false]]);
  buttonLable = GlobalConstants.OK_BUTTON;
  profileName: string;
  errorMessageText = GlobalConstants.PAGE_ERROR_MESSAGE;
  errorMessageText1 = GlobalConstants.PAGE_ERROR_MESSAGE1;
  errorMessageText2 = GlobalConstants.PAGE_ERROR_MESSAGE2;
  errorMessageText3 = GlobalConstants.PAGE_ERROR_MESSAGE3;
  errorMessageText4 = GlobalConstants.PAGE_ERROR_MESSAGE4;
  errorMessageText5 = GlobalConstants.PAGE_ERROR_MESSAGE5;
  errorMessageText6 = GlobalConstants.PAGE_ERROR_MESSAGE6;
  internalName = GlobalConstants.INTERNAL_NAME;
  isRegionalHQ: boolean;
  isLogoNone: boolean;
  globConst = GlobalConstants;
  pagelen: number;
  previewType:string;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  bgColorSelected =  GlobalConstants.STORELOGO_BGCOLOR;
  isImageSizeErrorDeviceWallppr: boolean = false;
  isImageTypeErrorDeviceWallppr: boolean = false;
  isimageFormatDeviceWallppr: boolean;
  imgDoc = [];
  imgFileType: string = '';
  imgFileSize: string = '';
  imgFileName: string = '';
  isImageUploadErrorDeviceWallPaper: boolean;
  deviceWallPaper = GlobalConstants.DEVICE_WALLPAPER_ID;
  livePreviewData: any[];
  checkBtnDwp = '';
  checkBtnStrLogo = '';
  isDWPOptionSel: boolean = false;
  devideWallPaperId: string;
  isDWPEnabled: boolean;
  wallPaperImagUpload = GlobalConstants.DEVICE_IMG_LI;
  showPreviewLayout: boolean;
  enableAIIPOS: boolean = false;
  deviceExists: boolean;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private router: Router,
    private logoContentService: LogoContentService,
    private storeLogoService: StoreLogoService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cmnService: CommonService, private dataService: DataService,
    private createProfileService: CreateProfileService,
    private profileStoreService: ProfileStoreService,
    private appGlobal: AppGlobal,
    private sendToStoreService: SendToStoreService,
    private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.logoContentIdInfo = '';
    this.bgColorSelected = GlobalConstants.STORELOGO_BGCOLOR;
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
    if (this.profileStoreService.currentWorkingProfile) {
      this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
      this.profileName = this.profileDataSet.profileName;
      this.isDWPEnabled = Utils.checkOSTypeWindowsOrUWP(this.profileDataSet);
      this.cmnService.editProfileName(this.profileName);
    }
    this.cmnService.pageObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data) => {
      if(data.media.format === 'video/mp4' && ((data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS && data.fullScreenCheckbox) || (data.previewType === GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE && data.idleExpFullscreenEnabled))) {
        this.showPreviewLayout = false;
      } else {
        this.showPreviewLayout = true;
      }
    });
    this.pushToDevice = false;
    this.sendLogoImageButtonText = '';
    this.storeDefaultLogoContentIdInfo = '';
    this.direction = this.cmnService.direction;
    this.placementWithoutLogo = this.direction === "rtl" ? 'left' : 'right';
    this.placementWithLogo = this.direction === "rtl" ? 'right' : 'left';
    this.retailHQUser = sessionStorage.getItem('userRole');
    this.isRetailerUser = (this.retailHQUser === 'retailHQUser') || false;
    this.isRegionalHQ = (this.retailHQUser === 'regionalHQ') || false;
    this.isStoreUser = (sessionStorage.getItem(GlobalConstants.USER_ROLE) === GlobalConstants.STORE_USER) || false;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userAccount: User) => {
        this.isRemoveEnabled = userAccount.isRemoveEnabled;
      });
    if (this.deviceStoreLogoOtherData) {
      this.setIndex(1);
    }
    this.getAllLogoContentsByUser();
    if (this.presentPage !== this.profile_page) { // Call this function only when in asset library since profile-> store logos has different HTML page
      this.getAllStoreLogosByUser();
    }
    this.pages = {};
    this.isDisabled = false;
    this.editCheck = false;
    // dummy data to preview page
    this.cmnService.pageDataTologoObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        // Once page is updated.
        const logoContent = this.contentGrpData.logoContent;
        let configurations = logoContent.configurations;
        if (res.data.media.url !== '') {
          this.prepareMediaSet(res, logoContent.id);
        }
        const checkJson = this.checkExistance(configurations.contentGroupPages, 'pageNum', res.number);
        if (checkJson.hasMatch) {// If there is configuration object already for the page number
          // Update the pages
          configurations.contentGroupPages[checkJson.matchedIndex] = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
        } else {
          const logoContentGroupPage: LogoContentGroupPage = {
            pageNum: res.number,
            title: res.data.heading,
            titleFontColor: res.data.hcolor,
            bgColor: res.data.bgcolor,
            bodyCopy: res.data.body,
            bodyCopyFontSize: this.fontSizeNumber(res.data.size),
            bodyCopyFontColor: res.data.bcolor,
            UiLayout: this.getUILayoutNameByID(res.data.layout),
            linkedAsset: res.data.media.url !== '' ? true : false,
            linkedAssetFileType: res.data.media.format,
            fileName: res.data.media.name,
            previewType: res.data.previewType,
            idleExpFullscreenEnabled: res.data.idleExpFullscreenEnabled,
            fullScreenCheckbox: res.data.fullScreenCheckbox,
          };
          configurations.contentGroupPages.push(logoContentGroupPage);
        }
        this.contentGrpData.logoContent = logoContent;
        this.cmnService.setRetailGifValue(false);
      });

    // set presentpage
    let currentdetailPage = this.router.url;
    const pageName = currentdetailPage.lastIndexOf('/');
    if (currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    }
    else if (currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    else if (currentdetailPage === RouterConstants.DEVICE_STORE_LOGO) {
      this.presentPage = GlobalConstants.DEVICE_STORE_LOGO;
    }
    this.setDeviceWallPaperData();
  }
    checkDWPisUseruploaded(profileDataSet) {
      if (profileDataSet?.deviceWallpaper && profileDataSet?.deviceWallpaper[0]) {
        const devicewallPaperData = profileDataSet?.deviceWallpaper[0] as DeviceWallpaper;
        this.devideWallPaperId = devicewallPaperData?.deviceWallpaperId;
        if (this.devideWallPaperId && this.devideWallPaperId?.indexOf(profileDataSet?.profileId) > -1) {
          this.bgColorSelected = devicewallPaperData?.bgColor  || GlobalConstants.STORELOGO_BGCOLOR;
          return true;
        }
        return false;
      }
      return false; 
    }
    setDeviceWallPaperData() {
    this.imgFileName = '';
    this.deviceWallPaperContent = [];
    if (this.profileDataSet?.deviceWallpaper && this.profileDataSet?.deviceWallpaper[0]?.deviceWallpaperId) {
          this.isDWPOptionSel = true;
          if (this.checkDWPisUseruploaded(this.profileDataSet)) {
            this.isImageSizeErrorDeviceWallppr = false;
            this.isImageTypeErrorDeviceWallppr = false;
            this.checkBtnDwp = GlobalConstants.UPLOAD_IMG_TEXT;
            this.checkBtnStrLogo = '';
            this.getDeviceWallpaperByProfileId();
          } else {
            this.checkBtnStrLogo = GlobalConstants.MAKE_LOGO_WALPAPER_TEXT;
            this.checkBtnDwp = '';
          } 
          this.setLivePreview();
    } else {
      this.checkBtnStrLogo = '';
      this.checkBtnDwp = '';
      this.setLivePreview();
    }
  }
  openPopupError(modal) {
    this.modalService.open(modal);
  }
  getPageError(data) {
    this.pageError.set(data[1], data[0])
  }
  resetPage() {
    this.pageError = new Map([[1, false], [2, false], [3, false]]);
  }
  goToErrorPage() {
    if (this.pageError.get(1) === true) {
      this.tabIndex = 4
    } else if (this.pageError.get(2) === true) {
      this.tabIndex = 5
    } else {
      this.tabIndex = 6
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  checkExistance(data, key, compValue) {
    const checkJSON = {
      hasMatch: false,
      matchedIndex: -1
    };
    for (let index = 0; index < data.length; index += 1) {
      if (data[index][key] === compValue) {
        checkJSON.hasMatch = true;
        checkJSON.matchedIndex = index;
        break;
      }
    }

    return checkJSON;
  }

  // To hold all pages media objects and its metada.
  prepareMediaSet(res: any, id: string) {
    const checkJson = this.checkExistance(this.mediaObjects, 'pageNum', res.number);
    if (checkJson.hasMatch) {
      // Update the pages
      this.mediaObjects[checkJson.matchedIndex] = {
        id: id,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        this.mediaObjects[checkJson.matchedIndex].uploaded = true;
      }
    } else {
      const dataObj: any = {
        id: id,
        media: res.data.media,
        pageNum: res.number
      };
      if (typeof res.data.media.fileObj === 'object' && res.data.media.fileObj) {
        dataObj.uploaded = true;
      }
      this.mediaObjects.push(dataObj);
    }

  }

  updateLCG() {
    const updateLogoContent: CreateLogoContentResponse = this.contentGrpData as CreateLogoContentResponse;
    // Once page is updated.
    const logoContent = updateLogoContent.logoContent;
    if (typeof logoContent.configurations !== 'string') {
      logoContent.configurations = JSON.stringify(logoContent.configurations);
    }
    this.logoContentService.putLogoContentById(JSON.stringify(logoContent), updateLogoContent.logoContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (putLogoContentResponse: CreateLogoContentResponse) => {
        // Once the update call is successful, call a PUT call for the logo
        for (const each of this.mediaObjects) {
          if (each.uploaded) {
            await this.updateMedia(each);
          }
        }
        this.deviceExists = putLogoContentResponse.logoContent.deviceExists;

        if (this.presentPage === this.profile_page) {
          this.openModal(this.showModal);
        } else if (this.editCheck && this.presentPage === this.assets_page && putLogoContentResponse.logoContent.deviceExists) {
          this.openModal(this.applyModal);
        } else {
          this.pages = {};
          this.clickable = false;
          this.setIndex(1);
          this.getAllLogoContentsByUser();
        }
      },
        error => {
        }
      );
  }

  updateMedia(each) {
    return new Promise((resolve, reject) => {
      this.logoContentService.putS3LogoContentByPageId(each.media.fileObj,
        each.media.name.split('.')
          .pop(), each.id, each.pageNum.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(
          (data) => {
            resolve(data);//To-Do: we should handle what if response code is other than 200
          },
          error => { // do something
          }
        );
    });
  }

  fontSizeNumber(size) {
    if (size === GlobalConstants.SMALL) { return 12; }
    if (size === GlobalConstants.MEDIUM) { return 14; }
    if (size === GlobalConstants.LARGE) { return 16; }
  }

  getUILayoutNameByID(id) {// TODO - Confirm with Sujay if layout name is correct
    if (id === 1) {
      return '2_col_right_asset';
    } else if (id === 2) {
      return '2_col_left_asset';
    } else if (id === 3) {
      return '1_col_mid_asset';
    }
  }

  getAllStoreLogosByUser() {
    this.isImgVideoSizeInfoEnabled = this.cmnService.isSizeContraintsEnabled;
    // console.log('Component, all store logo, My userid:: ' + sessionStorage.getItem('userId'));
    this.storeLogoService.getAllStoreLogoByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllStoreLogoResponse => {
        const storeLogos = [];
        const getStoreLogoByUserResponse: GetStoreLogoByUserResponse = getAllStoreLogoResponse as GetStoreLogoByUserResponse;
        getStoreLogoByUserResponse.storeLogo.forEach(storeLogo => {
          const reader = new FileReader();
          const storeLogoViewModel: StoreLogoViewModel = storeLogo as StoreLogoViewModel;
          this.storeLogoService.getStoreLogoById(storeLogo.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                storeLogoViewModel.imageData = reader.result;
                const storeLogoConfiguration = JSON.parse(storeLogo.configurations) as StoreLogoConfiguration;
                storeLogoViewModel.fileName = storeLogoConfiguration.fileName;
                storeLogos.push(storeLogoViewModel);
                storeLogos.forEach(ele => {
                  ele.shortFileName = this.getShortFileName(ele.fileName);
                  ele.isdefault = ele.isdefault ? ele.isdefault : false;
                  ele.updateTime = new Date(ele.updateTime);
                  ele.updateTimeDisplay = new Date(ele.updateTime).toLocaleString()
                    .replace(',', '');
                });
                this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
                this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
                this.sortBy('uploadDate');
                // this.storeLogos = defaultStoreLogos.concat(nonDefaultStoreLogos);
              }, false);

              if (imageData) {
                reader.readAsDataURL(imageData);
              }
              this.cmnService.setRetailGifValue(false);
            },
              error => {
                // do something
              });
          // this.configurations.push(JSON.parse(storeLogo.configurations) as LogoContentConfiguration);
        });
        this.cmnService.setRetailGifValue(false);
      },
        error => {
          // do something
        });
  }

  getAllLogoContentsByUser() {
    this.editCheck = false;
    // console.log('In component, My userid:: ' + sessionStorage.getItem('userId'));
    this.logoContentService.getAllLogoContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllLogoContentResponse => {
        this.getLengthDeviceLogo = getAllLogoContentResponse.logoContent.length;
        this.logoContentLength.emit(this.getLengthDeviceLogo);
        this.allLogoContentGroups = (getAllLogoContentResponse.logoContent as LogoContent[]);
        this.configurations = [];
        this.isLogoNone = this.presentPage === this.profile_page ? true : false;
        this.allLogoContentGroups.forEach(logoContentGroup => {
          try {
            this.configurations.push(JSON.parse(logoContentGroup.configurations) as LogoContentConfiguration);
          } catch (err) {
            console.log(err);
          }
        });
        // display logo content groups using displaylogocontentgroups var as configurations is coming as string
        this.displayLogoContentGroups = [];
        this.allLogoContentGroups.forEach(ele => {
          try {
            ele.configurations = JSON.parse(ele.configurations);
          }
          catch (err) {
            console.log(err);
          }
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayLogoContentGroups.push(ele);
        });
        this.deviceLogoContentId.emit(this.displayLogoContentGroups)
        this.displayLogoContentGroups.forEach(element => {
          // adding this custom property to know which logo content is expanded
          element.isExpanded = false;
          element.previewTabIndex = 0; // For new implementation of preview IIT2_4653
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime);
            element.updateTimeDisplay = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          if (element.configurations?.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          // if deleting make it true
          element.isDeleted = false;



          // TODO: Is the below commented code block needed?
          // fetch images from s3
          // this.fetchImagesForLogoCGPages(element.id);

          // converting date for display purpose:
          if (element && element.configurations) {
            if (element.configurations?.publishTime && !element.configurations.isPublishDateNow) {
              // changing it to old format
              element.configurations.publishTime = Utils.ChangetoOldFormat(element.configurations.publishTime);
              // element.configurations.publishTime = new Date(element.configurations.publishTime).toLocaleString()
              //   .replace(',', '');
            }
            if (element.configurations.expireTime && element.configurations.expireTime !== GlobalConstants.NEVER) {
              // changing it to old format
              element.configurations.expireTime = Utils.ChangetoOldFormat(element.configurations.expireTime);
              // element.configurations.expireTime = new Date(element.configurations.expireTime).toLocaleString()
              //   .replace(',', '');
            }
            if (element.configurations.expireTime && element.configurations.expireTime === GlobalConstants.NEVER) {
              element.configurations.expireTime = LanguageConstants.NEVER;
            }
          }
          if ((this.presentPage === this.profile_page)) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
          // For content expired notification
          element.isContentExpires = Utils.getExpiredContentdata(element);
        });
        this.sortByDate();
        if (this.presentPage === this.profile_page) {
          this.selctedContGrpsForProfile = {
            contentGrps: []
          };
          this.prefillProfileData(); // prefill already slected values
          this.displayLogoContentGroups.forEach((element, index) => {
            element.index = index;
            if (this.isLogoNone) {
              this.isLogoNone = !element.showOnDevice;
            }
          });
          // TODO MULTIPLE CONDITIONS
          if (this.showDevice) {
            let logCont = this.displayLogoContentGroups
              .filter(a => a.addToPackage === true)
              .sort((a, b) => new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime());
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.LOGO_CONTENT_GRP_MAX_IN_PACKAGE) {
              this.setPackageNshowOnDeviceVal(logCont[0].index, false); // if limit reached. set values to false since we are de-selecting
            }
            if (this.selctedContGrpsForProfile.showOnDevice) {
              this.findIndexAndSetValue(GlobalConstants.DISPLAY_LOGO_CONTENT, GlobalConstants.ID, false); // de-select in display logo content
              this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.LOGO_CONTENT_ID, false); // de-select in selectedCntGrps
            }
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.LOGO_CONTENT_GRP_MAX_IN_PACKAGE) { // Since maximum limit reached remove the earliest created one
              this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
                .filter(a => a.logoContentId !== logCont[0].id);
            }
            this.displayLogoContentGroups[0].addToPackage = true; // add to package/showondevice since selected yes on pop-up
            this.displayLogoContentGroups[0].showOnDevice = true;
            this.pushToSelectedGrps(0);
            this.selctedContGrpsForProfile.showOnDevice = this.displayLogoContentGroups[0].id;
            this.createProfileService.updateProfile(
              this.profileDataSet?.profileId, { logoContents: this.selctedContGrpsForProfile.contentGrps }
            )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                // update back to profile/ and profile store
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
                this.cmnService.setRetailGifValue(false);
              });
          }
        }
        this.cmnService.setRetailGifValue(false);
      },
        error => {
          // do something
        }
      );
  }

  getDeviceWallpaperByProfileId() {
    const profId = this.profileDataSet?.profileId;
    this.isimageFormatDeviceWallppr = false;
    this.isImageSizeErrorDeviceWallppr = false;
    this.isImageTypeErrorDeviceWallppr = false;
    this.storeLogoService.getDeviceWallPaperById(profId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async getDWPByIDResponse => {
        const dwpViewModel: DeviceWallpaperViewModel = getDWPByIDResponse as DeviceWallpaperViewModel;
        const storeLogoConfiguration = JSON.parse(getDWPByIDResponse?.deviceWallpaper?.configurations) as StoreLogoConfiguration;
        await this.getDWPImageById(profId, dwpViewModel, storeLogoConfiguration);
      });
    }
    
    getDWPImageById(profileId, dwpModel, storeLogoConfig) {
      return new Promise((resolve, reject) => {
        dwpModel.fileName = storeLogoConfig.fileName;
        this.imgFileName = storeLogoConfig.fileName
        const reader = new FileReader();
        this.storeLogoService.getDeviceWallpaperByIdFromS3(profileId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((resp) => {
            reader.onload= () => {
            dwpModel.imageData = reader.result;
            this.setLivePreview();
          };
          reader.readAsDataURL(resp);
          this.deviceWallPaperContent?.push(dwpModel);
          this.isimageFormatDeviceWallppr = true;
          resolve(resp);
        },
          error => { // do something
          });
    });
  }

  changeLockContentStatus(id: string, eventObj: any, object: []) {
    const status = eventObj.target.checked ? GlobalConstants.LOCK_CONTENT_LOCK : GlobalConstants.LOCK_CONTENT_UNLOCK;
    this.cmnService.changeLockContentStatus(id, status, AssetLibraryConstants.LOGO_CONTENTS)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(response => {
        this.displayLogoContentGroups[this.displayLogoContentGroups.indexOf(object)].islocked = eventObj.target.checked;
      });
  }

  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.LOGO_CONTENTS + AssetLibraryConstants.SLASH + gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 3,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,

    };
    return this.pageGrpForm;
  }
  getFontSize(size: number) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  reloadLogoContent(value: number) {
    // Call the API to get all logo content by user
    this.getAllLogoContentsByUser();
    this.setIndex(value);
  }
  close() {
    this.dataService.setLogoContent(undefined);
    // TO-DO: temp fix for showing published name as balnk after edit.
    if (this.contentGrpData) {
      for (let each of this.displayLogoContentGroups) {
        if (each.id === this.contentGrpData.logoContent.id) {
          if (typeof each.configurations === 'string') {
            each.configurations = JSON.parse(each.configurations);
          }
          break;
        }
      }
    }

    this.getAllLogoContentsByUser();
    this.setIndex(1);
    this.clickable = false;
    this.mediaObjects = [];
    this.pages = {};
    this.editCheck = false;
  }
  prefillProfileData() {
    // for edit profile - logo content tab
    this.profileDataSet = JSON.parse(JSON.stringify(this.profileStoreService.currentWorkingProfile));
    if (this.profileDataSet && this.profileDataSet?.profileId) {
      this.profileLogoContentData = this.profileDataSet.logoContents;
      if (this.profileLogoContentData?.length) {
        if (this.profileDataSet?.logoContents?.length === 1 && !this.profileDataSet?.logoContents[0].showOnDevice && this.profileDataSet?.logoContents[0].logoContentId === undefined) {
          this.selctedContGrpsForProfile.contentGrps = [];
        } else {
          this.selctedContGrpsForProfile.contentGrps = this.profileDataSet.logoContents;
        }
        this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
          let contentIdInd = this.displayLogoContentGroups.findIndex(each => each.id === ele.logoContentId);
          if (contentIdInd != -1) {
            this.displayLogoContentGroups[contentIdInd].addToPackage = true;
            this.displayLogoContentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
            if (ele.showOnDevice) {
              this.selctedContGrpsForProfile.showOnDevice = this.displayLogoContentGroups[contentIdInd].id;
            }
          }
        });
      }
    }
  }

  setIndex(value: number) {
    this.tabIndex = value;
    // if user in profile and going to logo content group tab -> refresh this.selctedContGrpsForProfile
    if (this.presentPage === this.profile_page && this.tabIndex === 1) {
      this.selctedContGrpsForProfile = {
        contentGrps: []
      };
      this.displayLogoContentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
      this.prefillProfileData();
    }
    if ( this.tabIndex === 2 && this.presentPage === this.profile_page) {
      this.isDWPOptionSel = false;
      this.setDeviceWallPaperData();
    }
    this.cmnService.emitTabIndex(this.tabIndex);
  }

  refreshLGCdata() {
    this.getAllLogoContentsByUser();
    this.setIndex(1);
    this.mediaObjects = [];
  }

  setCreatedGrpID(data) {
    this.buttonName = this.logoContentService.buttonName;
    if (typeof data === 'object' && data.cancel) {
      this.setIndex(1);
      this.pages = {};
      this.editCheck = false;
    } else {
      this.contentGrpData = data;
      if (typeof this.contentGrpData.logoContent.configurations === 'string') {
        this.contentGrpData.logoContent.configurations =
          JSON.parse(this.contentGrpData.logoContent.configurations) as LogoContentConfiguration;
      }
      this.page = 1; // set pagination to 1
      this.pages.page1 = true;
      this.isPage3Created = this.checkPages();
      this.showLogContentName = this.contentGrpData.logoContent.configurations.publishedName;
      this.clickable = true;
      this.setIndex(4);
    }
    // this.mediaObjects = [];
  }
  /*when user opens pages*/
  setPreviewLayout(data) {
    this.LCGlayout = data;
  }
  /*when users slects layout*/
  setLayout(selected) {
    this.LCGlayout = selected;
    this.cmnService.emitLayout(selected);
  }

  redirectToLogin() {
    this.router.navigateByUrl(RouterConstants.LOGIN_PAGE_LINK);
  }

  trackByConfiguration(index: number, el: string): number {
    return index;
  }

  trackByStoreLogo(index: number, el: string): number {
    return index;
  }

  fetchImagesForLogoCGPages(logoCGId: string) {
    this.displayLogoContentGroups.forEach(element => {
      // console.log('element.id:: ' + element.id);
      // console.log('element.configurations: '+ JSON.stringify (element.configurations));
      if (element.id === logoCGId && element.configurations && element.configurations.contentGroupPages) {
        element.configurations.contentGroupPages.forEach(page => {
          if (page.linkedAsset) {
            const reader = new FileReader();

            this.logoContentService.getLogoContentByPageId(logoCGId, page.pageNum)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(imageData => {
                reader.addEventListener('load', () => {
                  page.image = reader.result;
                }, false);

                if (imageData) {
                  reader.readAsDataURL(imageData);
                }
              },
                error => {
                  // do something
                });
          }

        });
      }
    });
  }

  // get details of logo content by id when click on arrow besides particular logo content group
  getLogoContentDetails(id: string) {
    // TODO check with Sujay or Magesh to fetch the id of existing logo  - first ngfor if i can change
    this.logoContentService.getLogoContentById(id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getLogoContentById => {
        const logoContentGrpdetails = (getLogoContentById.logoContent as LogoContent);
        this.logoContentData = logoContentGrpdetails;
        // console.log('logoContentGrpDetails--', logoContentGrpdetails);
      },
        error => {
          // do something
        });
  }
 
  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];
    if (file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.isImageSizeErrorDeviceWallppr = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
        this.isImageSizeError = false;
      }
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }
    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const storeLogo = {
          fileName: file.name
        };
        this.storeLogoService.createStoreLogo(JSON.stringify(storeLogo))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(createStoreLogo => {
            const createStoreLogoResponse: CreateStoreLogoResponse = createStoreLogo as CreateStoreLogoResponse;
            const storeLogoViewModel: StoreLogoViewModel = createStoreLogoResponse.storeLogo as StoreLogoViewModel;
            this.storeLogoService.uploadImage(file, createStoreLogoResponse.storeLogo.id, file.name.split('.')
              .pop())
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                if (!this.otherStoreLogos || (this.otherStoreLogos && this.otherStoreLogos.length === 0)) {
                  this.otherStoreLogos = [];
                }
                storeLogoViewModel.imageData = event.target.result;
                storeLogoViewModel.shortFileName = this.getShortFileName(file.name);
                storeLogoViewModel.fileName = file.name;
                storeLogoViewModel.updateTime = new Date(storeLogoViewModel.updateTime);
                storeLogoViewModel.updateTimeDisplay = new Date(storeLogoViewModel.updateTime).toLocaleString()
                  .replace(',', '');
                this.otherStoreLogos.push(storeLogoViewModel);
                this.sortBy('uploadDate');
              },

                error => {
                  // do something
                });
          },
            error => {
              // do something
            });

      });
      this.googleAnalyticsService.assetLibraryStoreLogoAdded();
    }

    reader.readAsDataURL(file);
  }

  getShortFileName(fileName: string): string {
    let finalName: string;
    if (fileName?.split('.')[0].length > 7) {
      let flname = fileName;
      let extension = fileName.substring(fileName.lastIndexOf('.') + 1);
      flname = fileName.substring(0, 7);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  getDetailsOfLogoCG(id: string) {
    this.displayLogoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        element.previewTabIndex = 0;// IIT2_4653
        this.cmnService.scrollToBottom(id);
      }
    });
  }

  sortBy(sortValue: string) {
    this.page = 1;
    switch (sortValue) {
      case 'createDate': {
        this.sortValue = GlobalConstants.CREATED_DATE;
        this.displayLogoContentGroups.sort((logo1, logo2) => logo2.updateTime - logo1.updateTime);
        break;
      }
      case 'groupName': {
        this.sortValue = GlobalConstants.GROUP_NAME;
        this.displayLogoContentGroups.sort((logo1, logo2) =>
          logo1.configurations.publishedName.localeCompare(logo2.configurations.publishedName));
        break;
      }
      case 'uploadDate': {
        this.storeLogoSortValue = GlobalConstants.UPLOAD_DATE;
        this.otherStoreLogos.sort((logo1, logo2) => (logo2.updateTime as any) - (logo1.updateTime as any));
        // this.otherStoreLogos.sort((logo1, logo2) => logo2.updateTime.localeCompare(logo1.updateTime));
        break;
      }
      case 'fileName': {
        this.storeLogoSortValue = GlobalConstants.FILE_NAME;
        this.otherStoreLogos.sort((logo1, logo2) =>
          logo1.fileName.localeCompare(logo2.fileName));
        break;
      }
      default:
        break;
    }
  }

  sortByDate() {
    this.page = 1;
    this.sortValue = GlobalConstants.CREATED_DATE;
    // this.displayLogoContentGroups.sort((logo1, logo2) => logo2.updateTime.localeCompare(logo1.updateTime));
    this.displayLogoContentGroups.sort((logo1, logo2) => logo2.updateTime - logo1.updateTime);
  }

  sortByName() {
    this.page = 1;
    this.sortValue = GlobalConstants.GROUP_NAME;
    this.displayLogoContentGroups.sort((logo1, logo2) =>
      logo1.configurations.publishedName.localeCompare(logo2.configurations.publishedName));
  }

  openPopup(modal, pageNumber) {
    this.modalService.open(modal);
    this.whichPageDelete = pageNumber;
  }

  deletePages(which) {
    this.isPage3Created = false;
    let pagesLen = Object.entries(this.pages).length;
    this.pagelen = Object.entries(this.pages).length;
    if (pagesLen > 1) {
      delete this.pages["page" + (pagesLen)];
      this.pagelen -= 1;
    } else {
      this.page1.updated(undefined,undefined,'',1);
    }
    let configurations;
    let updatedPages = [];
    
    if (typeof this.contentGrpData.logoContent.configurations === 'string') {
      configurations = JSON.parse(this.contentGrpData.logoContent.configurations) as LogoContentConfiguration;
    } else {
      configurations = this.contentGrpData.logoContent.configurations as LogoContentConfiguration;
    }
    configurations.contentGroupPages.splice(which, 1);
    configurations.contentGroupPages.forEach((e, i) => {
      e.pageNum = i + 1;
      updatedPages.push(e);
    });

    if (this.page1) {
      this.page1.updated(configurations,AssetLibraryConstants.LOGO_CONTENTS,'logo');
    } else if (this.page2) {
      this.page2.updated(configurations,AssetLibraryConstants.LOGO_CONTENTS,'logo');
    } else {
      this.page3.updated(configurations,AssetLibraryConstants.LOGO_CONTENTS,'logo');
    }
  }

  deleteLogoCG(logoCGID: string) {
    const index = this.displayLogoContentGroups.findIndex(d => d.id === logoCGID); // find index in your array
    // make that isdeleted tru for this id
    this.displayLogoContentGroups[index].isDeleted = true;
    // delete logo API call
    this.logoContentService.deleteLogoContentById(logoCGID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {
        if (index >= 0) {
          this.displayLogoContentGroups.splice(index, 1); // remove element from array
        }
        this.closeModal(this.deleteModal);
      },
        error => {
          // do something
          this.closeModal(this.deleteModal);
        });
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModalSL(logoID) {
    this.storelogos = this.defaultStoreLogos.concat(this.otherStoreLogos);
    // console.log(this.storelogos);
    this.logoToDelete = this.storelogos.find(ele => ele.id === logoID).id;
    this.logoToDeleteName = this.storelogos.find(ele => ele.id === logoID).fileName;
    // console.log('Store Logo will be Deleted-', this.storelogos.find(ele => ele.id === logoID).fileName);
    this.openModal(this.deleteStoreLogoModal);
  }

  openDeleteModal(logoCGID: string) {
    this.logoCGToDelete = this.displayLogoContentGroups.find(ele => ele.id === logoCGID).id;
    this.logoCGToDeleteName = this.displayLogoContentGroups.find(ele => ele.id === logoCGID).configurations.publishedName;
    this.openModal(this.deleteModal);
  }

  openSendLogoContentToAccountModal(logoCGID: string) {
    this.sendButtonText = GlobalConstants.LOGO_BUTTON_TEXT;
    this.logoContentIdInfo = logoCGID;
    this.sendNameToStore = this.displayLogoContentGroups.find(ele => ele.id === logoCGID).configurations.publishedName;
    this.openModal(this.sendToAccountModal);
  }

  openDefaultStoreContentToAccountModal(defaultStoreLogoId: string) {
    this.sendLogoImageButtonText = GlobalConstants.STORE_LOGO_TEXT;
    this.storeDefaultLogoContentIdInfo = defaultStoreLogoId;
    this.sendLogoImageName = this.defaultStoreLogos.find(ele => ele.id === defaultStoreLogoId).fileName;
    this.openModal(this.sendToAccountModal);
  }

  openOtherStoreContentToAccountModal(otherStoreLogoId: string) {
    this.sendLogoImageButtonText = GlobalConstants.STORE_LOGO_TEXT;
    this.storeOtherLogoContentIdInfo = otherStoreLogoId;
    this.storeDefaultLogoContentIdInfo = otherStoreLogoId;
    this.sendLogoImageName = this.otherStoreLogos.find(ele => ele.id === otherStoreLogoId).fileName;
    this.openModal(this.sendToAccountModal);
  }

  setAsDefaultStoreLogo(storeLogoId: string, isDefault: boolean) {

    this.storeLogoService.putStoreLogo(isDefault, storeLogoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(putStoreLogoResponse => {
        // console.log('putStoreLogoResponse:: ' + JSON.stringify(putStoreLogoResponse));

        if (!isDefault) {
          // Here we are doing Remove from default. So remove from default store logo and add to other store logo catg
          this.defaultStoreLogos.forEach(element => {
            // Set is Default as false for all
            element.isdefault = false;
          });
          this.otherStoreLogos = this.otherStoreLogos.concat(this.defaultStoreLogos);
          this.defaultStoreLogos.pop();
        } else {
          // Here we are adding as default. So remove from other store logo and add to default store logo catg
          const storeLogos = this.defaultStoreLogos.concat(this.otherStoreLogos);
          storeLogos.forEach(element => {
            // Set is Default as false for all
            element.isdefault = false;
            if (element.id === storeLogoId) {
              element.isdefault = true;
              this.defaultStoreLogos.push(element);
            }
          });
          this.defaultStoreLogos = storeLogos.filter(ele => ele.isdefault);
          this.otherStoreLogos = storeLogos.filter(ele => !ele.isdefault);
        }
      },
        error => {
          // do something
        });
  }

  deleteStoreLogo(storeLogoId: string) {
    // delete store logo api call if different other deletelogocg()
    // Call delete logo for S3 server first
    // Then call delete logo

    this.storeLogoService.deleteS3StoreLogoById(storeLogoId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(deleteResponse => {

        this.storeLogoService.deleteStoreLogoById(storeLogoId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(deleteResponse => {
            // console.log('Delete Store logo success --', deleteResponse);
            const logoToDel = this.storelogos.find(d => d.id === storeLogoId);
            if (logoToDel && logoToDel.isdefault) { this.defaultStoreLogos.splice(0, 1); } else {
              const index = this.otherStoreLogos.findIndex(logo => logo.id === storeLogoId);
              if (index >= 0) {
                this.otherStoreLogos.splice(index, 1);
              }
            }
            this.closeModal(this.deleteStoreLogoModal);
          },
            error => {
              // do something
              // console.log('Delete Store logo error --', error);
              this.closeModal(this.deleteStoreLogoModal);
            });
      },
        error => {
          // do something
          // console.log('Delete S3 logo error --', error);
        });
  }

  editLogoContent(logoContentId: string) {
    this.mediaObjects = [];
    this.pages = {};
    const logoContentToEdit = this.displayLogoContentGroups.find(ele => ele.id === logoContentId);
    this.dataService.setLogoContent(logoContentToEdit);
    this.editCheck = true;
    for (let each of logoContentToEdit.configurations.contentGroupPages) {
      if (each.pageNum === 1) {
        this.pages.page1 = true;
      }
      if (each.pageNum === 2) {
        this.pages.page2 = true;
      }
      if (each.pageNum === 3) {
        this.pages.page3 = true;
      }
    }
    this.pagelen = Object.entries(this.pages).length;
    this.contentGrpData = { logoContent: logoContentToEdit, responseContext: {} }; // set data to cntGrpData to show in pages.
    this.showLogContentName = logoContentToEdit.configurations.publishedName;
    this.setIndex(3);
    // this.contentGrpData.logoContent.configurations = JSON.stringify(this.contentGrpData.logoContent.configurations);
  }

  duplicateAndEditLogoContent(logoContentId: string) {

    const logoContentToEdit = this.displayLogoContentGroups.find(ele => ele.id === logoContentId);
    const logoContentConfig = logoContentToEdit.configurations;

    // TODO: Is the below commented code block needed?
    // logoContentConfig.contentGroupPages.forEach(page => {
    //   page.image = undefined;
    // });
    if (logoContentConfig?.publishTime && !logoContentConfig?.isPublishDateNow) {
      //changing it to old format
      logoContentConfig.publishTime = Utils.changeSaveDateFormat(logoContentConfig?.publishTime);

    }
    if (logoContentConfig?.expireTime && logoContentConfig?.expireTime !== GlobalConstants.NEVER) {
      //changing it to old format
      logoContentConfig.expireTime = Utils.changeSaveDateFormat(logoContentConfig?.expireTime);

    }
    const logoContent: LogoContentConfiguration = {
      publishedName: `Copy of ${logoContentConfig.publishedName}`,
      internalName: logoContentConfig.internalName,
      publishTime: logoContentConfig.publishTime ? logoContentConfig.publishTime : new Date().toString(),
      expireTime: logoContentConfig.expireTime ? logoContentConfig.expireTime : GlobalConstants.NEVER,
      contentScheduleTimezoneCode: logoContentConfig.contentScheduleTimezoneCode,
      type: GlobalConstants.LOGO_CONTENT_GROUP,
      contentGroupPages: logoContentConfig.contentGroupPages,
      formFactor: logoContentConfig.formFactor,
      isPublishDateNow: logoContentConfig.isPublishDateNow,
      isPublishExpiryNever: logoContentConfig.isPublishExpiryNever
    };
    this.logoContentService.createLogoContent(JSON.stringify(logoContent))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createLogoContentResponse => {
        this.getDetailsOfLogoCG(logoContentId);
        const createLogoContentResponseObj: CreateLogoContentResponse = createLogoContentResponse as CreateLogoContentResponse;
        const logoContentViewModel: LogoContentViewModel = createLogoContentResponseObj.logoContent as unknown as LogoContentViewModel;
        logoContentViewModel.configurations =
          JSON.parse(createLogoContentResponseObj.logoContent.configurations) as LogoContentConfiguration;

        // Loop and duplicate images
        if (logoContentToEdit?.configurations && logoContentToEdit.configurations.contentGroupPages?.length) {
          for (let page of logoContentToEdit.configurations.contentGroupPages) {
            await this.duplicateLogoContentImage(logoContentToEdit, logoContentViewModel, page);
          }
        }
        if (logoContentViewModel && logoContentViewModel.configurations) {
          if (logoContentViewModel.configurations?.publishTime && !logoContentViewModel.configurations.isPublishDateNow) {
            //changing it to old format
            logoContentViewModel.configurations.publishTime = Utils.ChangetoOldFormat(logoContentViewModel.configurations.publishTime);
          }
          if (logoContentViewModel.configurations.expireTime && logoContentViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
            //changing it to old format
            logoContentViewModel.configurations.expireTime = Utils.ChangetoOldFormat(logoContentViewModel.configurations.expireTime);
          }
        }
        this.dataService.setLogoContent(logoContentViewModel);
        this.editCheck = true;
        for (let each of logoContentViewModel.configurations.contentGroupPages) {
          if (each.pageNum === 1) {
            this.pages.page1 = true;
          }
          if (each.pageNum === 2) {
            this.pages.page2 = true;
          }
          if (each.pageNum === 3) {
            this.pages.page3 = true;
          }
        }
        this.contentGrpData = {
          logoContent: logoContentViewModel,
          responseContext: {}
        }; // set data to cntGrpData to show in pages.
        const tempViewModel: any = logoContentViewModel; // dummy instance to add all required  flags for expand,delete,sort by date&time format
        tempViewModel.isExpanded = false;
        tempViewModel.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        tempViewModel.previewTabIndex = 0;// IIT2_4653
        tempViewModel.createdByUser = (tempViewModel.createdByUser === this.userId) ? GlobalConstants.ME : tempViewModel.createdByUser;
        if (tempViewModel.updateTime) {
          tempViewModel.updateTime = new Date(tempViewModel.updateTime);
          tempViewModel.updateTimeDisplay = new Date(tempViewModel.updateTime).toLocaleString()
            .replace(',', '');
        }
        tempViewModel.isDeleted = false;

        // TODO: Is the below commented code block needed?
        // if (tempViewModel && tempViewModel.configurations) {
        //   if (tempViewModel.configurations.publishTime) {
        //     tempViewModel.configurations.publishTime = new Date(tempViewModel.configurations.publishTime).toLocaleString()
        //       .replace(',', '');
        //   }
        //   if (tempViewModel.configurations.expireTime && tempViewModel.configurations.expireTime !== GlobalConstants.NEVER) {
        //     tempViewModel.configurations.expireTime = new Date(tempViewModel.configurations.expireTime).toLocaleString()
        //       .replace(',', '');
        //   }
        // }
        tempViewModel.addToPackage = tempViewModel.showOnDevice = false;
        this.displayLogoContentGroups.unshift(tempViewModel);
        if (this.presentPage === this.profile_page) {
          this.displayLogoContentGroups.forEach((element, index) => {
            element.index = index;
          });
        }
        if (this.sortValue === 'Created Date') {
          this.sortBy('createDate');
        } else {
          this.sortBy('groupName');
        }
        this.showLogContentName = logoContent.publishedName;
        this.page = 1;
        this.setIndex(3);
      },
        error => {
        }
      );
  }

  duplicateLogoContentImage(logoContent: any, newLogoContent: any, page: any) {
    return new Promise((resolve, reject) => {
      if (page.linkedAsset) {
        this.logoContentService.getLogoContentByPageId(logoContent.id, page.pageNum)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(imageData => {
            this.logoContentService.putS3LogoContentByPageId(imageData, 'png', newLogoContent.id, page.pageNum) // Check how to get image type
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe((data) => {
                resolve(data);//ToDo: Need to add reject too.
              },
                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      } else {
        resolve({});//ToDo: just sending empty, to continue the flow;
      }
    });
  }

  addPage() {
    const keyLen = Object.keys(this.pages).length;
    if (keyLen === 0) {
      this.pages.page1 = true;
      this.setIndex(4);
    } else if (keyLen === 1) {
      this.pages.page2 = true;
      this.setIndex(5);
    } else {
      this.pages.page3 = true;
      this.setIndex(6);
    }
    this.pagelen = Object.entries(this.pages).length;
    this.isPage3Created = this.checkPages();
  }

  checkPages() {
    if (this.pages.page1 && this.pages.page2 && this.pages.page3) {
      return true;
    }

    return false;
  }

  createNewLogoContent() {
    this.mediaObjects = [];
    this.dataService.setLogoContent(undefined);
    this.tabIndex = 3;
  }

  //Adding content group objects for profile ---> for AddToProfile
  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      "logoContentId": this.displayLogoContentGroups[ind].id,
      "showOnDevice": this.displayLogoContentGroups[ind].showOnDevice
    });
  }

  //this function will be used in multiple places to set addToPackage, showOnDevice to true/false ---> for AddToProfile
  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displayLogoContentGroups[index].showOnDevice = this.displayLogoContentGroups[index].addToPackage = value;
  }

  //for AddToProfile
  findIndexAndSetValue(setValueTo: string, keyName: string, setValueAs: any) {
    if (setValueTo === GlobalConstants.DISPLAY_LOGO_CONTENT) {
      let checkInd = this.displayLogoContentGroups.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.displayLogoContentGroups[checkInd].showOnDevice = setValueAs;
    } else {
      let checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = setValueAs;
    }
  }
  removeShowonDevice() {
    this.displayLogoContentGroups.forEach(element => {
      element.isChecked = false;
    });

    if (this.presentPage === this.profile_page) {
      this.selctedContGrpsForProfile.showOnDevice = undefined;
      this.selctedContGrpsForProfile.contentGrps.forEach(value => {
        value['showOnDevice'] = false;
      })
    } else {
      this.selctedContGrpsForProfile.contentGrps = [{
        'logoContentId': undefined,
        'showOnDevice': false,
      }];
      this.deviceLogoContentId.emit(this.selctedContGrpsForProfile);
    }
  }

  addToProfile(eventObj: any, index: number, eventSource: string) {
    //for radio button selection
    if (eventSource === GlobalConstants.RADIO) {
      //if switching show on device one to others
      if (!this.selctedContGrpsForProfile.showOnDevice && this.displayLogoContentGroups[index].addToPackage) {
        this.selctedContGrpsForProfile.showOnDevice = this.displayLogoContentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.LOGO_CONTENT_ID, true);
        this.displayLogoContentGroups[index].showOnDevice = true;
      } // if show on device not selected.
      else if (this.selctedContGrpsForProfile.showOnDevice && this.displayLogoContentGroups[index].addToPackage) {
        this.findIndexAndSetValue(GlobalConstants.DISPLAY_LOGO_CONTENT, GlobalConstants.ID, false);
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.LOGO_CONTENT_ID, false);
        this.displayLogoContentGroups[index].showOnDevice = true;
        this.selctedContGrpsForProfile.showOnDevice = this.displayLogoContentGroups[index].id;
        this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.LOGO_CONTENT_ID, true);
      }
      else {
        eventObj.target.checked = false;
      }
    }
    //for checkbox  selection
    else if (eventSource === GlobalConstants.CHECK) {
      if (this.selctedContGrpsForProfile?.contentGrps?.length === 1 && (this.selctedContGrpsForProfile?.contentGrps[0]?.logoContentId === undefined
        || this.selctedContGrpsForProfile?.contentGrps[0]?.logoContentId === "")) {
        this.selctedContGrpsForProfile.contentGrps = [];
      }
      if (eventObj.target.checked) {
        if (this.selctedContGrpsForProfile.contentGrps?.length <= 2) {
          this.displayLogoContentGroups[index].addToPackage = eventObj.target.checked;
          this.pushToSelectedGrps(index);
        }

        else {
          eventObj.target.checked = false;
        }
      } else {
        if (this.displayLogoContentGroups[index].showOnDevice) {
          this.selctedContGrpsForProfile.showOnDevice = undefined;
        }
        this.setPackageNshowOnDeviceVal(index, false);
        let checkInd = this.selctedContGrpsForProfile.contentGrps.findIndex(d => d.logoContentId === this.displayLogoContentGroups[index].id);
        if (checkInd >= 0) {
          this.selctedContGrpsForProfile.contentGrps.splice(checkInd, 1);
        }
      }
    }
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      if (!this.selctedContGrpsForProfile?.contentGrps?.length) {
        this.selctedContGrpsForProfile.contentGrps = [{
          'logoContentId': undefined,
          'showOnDevice': false,
        }];
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.LOGO_CONTENT_GROUP, dataSet: this.selctedContGrpsForProfile.contentGrps, isDWPEnabled: this.isDWPEnabled });
      this.getAllContentGroups();
      //gtm(google tag manager)
      window['dataLayer'].push({
        'store_logo_content_added': true
      });
      if (this.isDWPEnabled) {
        this.setIndex(2);
      }
      else{
        this.sendToProfile("sendDeviceWalppr");
      }
    } else if (action === GlobalConstants.SEND_DWP) {
      let deviceWallPaperContent = [];
      const deviceWallpaperId = this.profileDataSet?.profileId + "_wp";
      if (this.deviceWallPaperContent?.length && this.isimageFormatDeviceWallppr) {
          deviceWallPaperContent?.push({
          deviceWallpaperId: deviceWallpaperId,
          showOnDevice: true,
          bgColor: this.bgColorSelected
        });
      } else {
        deviceWallPaperContent?.push({
          showOnDevice: false
        });
      }
      this.cmnService.emitDataToProfile({ page: GlobalConstants.DEVICE_WALLPAPER, dataSet: deviceWallPaperContent });
      this.getAllContentGroups();
      //gtm(google tag manager)
      window['dataLayer'].push({
        'device_wallpaper_content_added': true
      });
      this.cmnService.emitDataToProfile({ page: GlobalConstants.LOGO_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
      const wallPaperInfo = this.checkBtnDwp != '' ? this.checkBtnDwp :  GlobalConstants.MAKE_LOGO_WALPAPER_TEXT;
      this.googleAnalyticsService.profileDeviceWallPaper(this.profileDataSet?.profileId, this.profileName, wallPaperInfo);
      
    }
    else {
      if (this.isDWPEnabled && action != GlobalConstants.SKIP_DWP) {
        this.cmnService.emitDataToProfile({ page: GlobalConstants.LOGO_CONTENT_GROUP, dataSet: GlobalConstants.SKIP_DWP, dwpEnabled : true});
        this.setIndex(2);
      }else {
        this.cmnService.emitDataToProfile({ page: GlobalConstants.LOGO_CONTENT_GROUP, dataSet: GlobalConstants.SKIP });
      }
    }
    this.cmnService.scrollTopInitial();
  }

  disabledLogoContent(isDisable: boolean) {
    this.isDisabled = true;
  }

  redirectToList() {
    this.pages = {};
    this.clickable = false;
    this.closeModal(this.showModal);
    this.setIndex(1);
    this.getAllLogoContentsByUser();
  }

  redirectToApplyList() {
    this.pages = {};
    this.clickable = false;
    this.closeModal(this.applyModal);
    this.setIndex(1);
    this.getAllLogoContentsByUser();
  }

  showOnDevice() {
    this.showDevice = true;
    this.redirectToList();
  }

  applyToDevice(applyDevice: boolean) {
    const updateLogoContent: CreateLogoContentResponse = this.contentGrpData as CreateLogoContentResponse;
    // Once page is updated.
    const logoContent = updateLogoContent.logoContent;
    if (typeof logoContent.configurations !== 'string') {
      logoContent.configurations = JSON.stringify(logoContent.configurations);
    }
    logoContent.ispushedToDevice = applyDevice;
    logoContent.showOnDevice = applyDevice;
    if (!applyDevice) {
      logoContent.deviceExists = false;
    }
    else {
      logoContent.deviceExists = this.deviceExists;
    }
    this.logoContentService.putLogoContentById(JSON.stringify(logoContent), updateLogoContent.logoContent.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async (applyLogoContentResponse: CreateLogoContentResponse) => {
        this.redirectToApplyList();
      },
        error => {
        }
      );
  }

  closeApplyDevice() {
    this.applyDevice = false;
    if (!this.applyDevice) {
      const updateLogoContent: CreateLogoContentResponse = this.contentGrpData as CreateLogoContentResponse;
      // Once page is updated.
      const logoContent = updateLogoContent.logoContent;
      if (typeof logoContent.configurations !== 'string') {
        logoContent.configurations = JSON.stringify(logoContent.configurations);
      }
      this.logoContentService.putLogoContentById(JSON.stringify(logoContent), updateLogoContent.logoContent.id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(async (applyLogoContentResponse: CreateLogoContentResponse) => {
          // Once the update call is successful, call a PUT call for the logo
          for (const each of this.mediaObjects) {
            if (each.uploaded) {
              await this.updateMedia(each);
            }
          }
          this.displayLogoContentGroups.forEach(element => {
            if (element.id === applyLogoContentResponse.logoContent.id) {
              element.ispushedToDevice = false;
            }
          });

        },
          error => {
          }
        );
    }
    this.redirectToApplyList();
  }

  closeShowOnDevice() {
    this.showDevice = false;
    this.redirectToList();
  }



  // TODO CONDITIONS
  getAllContentGroups() {
    this.profileData = this.createProfileService.getProfileId();
    this.createProfileService.getAllSavedContentGroups(this.profileData).subscribe(resp => {
    })
  }

  navigate() {
    this.isNavigated = true;
    this.contentGrpData.logoContent.configurations.formFactor =
      Utils.getFormFactorNames(this.contentGrpData.logoContent.configurations.formFactor);
    if (this.contentGrpData.logoContent && this.contentGrpData.logoContent.configurations) {
      if (this.contentGrpData.logoContent.configurations?.publishTime && !this.contentGrpData.logoContent.configurations.isPublishDateNow) {
        //changing it to old format
        this.contentGrpData.logoContent.configurations.publishTime = Utils.ChangetoOldFormat(this.contentGrpData.logoContent.configurations.publishTime);
      }
      if (this.contentGrpData.logoContent.configurations.expireTime && this.contentGrpData.logoContent.configurations.expireTime !== GlobalConstants.NEVER) {
        //changing it to old format
        this.contentGrpData.logoContent.configurations.expireTime = Utils.ChangetoOldFormat(this.contentGrpData.logoContent.configurations.expireTime);
      }
    }
    this.dataService.setLogoContent(this.contentGrpData.logoContent);
    this.setIndex(3);
    this.clickable = false;
  }

  tabTrimString(data: string) {
    return Utils.trimString(data);
  }

  getSelectedStoreData(data) {
    this.deviceStoreLogoId.emit(data);
    this.sendToStoreService.sendLogoToStoreService(this.logoContentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isSendToStore = true;
        }
      });
  }

  getDefaultStoreLogoData(data) {

    this.sendToStoreService.sendStoreLogoService(this.storeDefaultLogoContentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isDefaultStoreSendToStore = true;
        }



      });
  }

  getOtherStoreLogoData(data) {
    this.sendToStoreService.sendStoreLogoService(this.storeOtherLogoContentIdInfo, data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(sendToStoreResponse => {
        if (sendToStoreResponse['response-context'].statusCode === GlobalConstants.SUCCESS_RESPONSE_CODE) {
          this.isOtherStoreSendToStore = true;
        }
      });
  }
  getDeviceLogoContentId(data) {
    this.deviceLogoContentId.emit(data);
  }
  getLogocontentParams(value) {
    this.defaultStoreLogos = value;
  }
  //IIT2_4653
  previewNavigate(ind, id) {
    this.displayLogoContentGroups.forEach(element => {
      if (element.id === id) {
        element.previewTabIndex = ind;
      }
    });
    if(ind ==  1) {
      this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
    }
    
  }

  disableFields() {
    this.cmnService.previewTypeObser
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(type => {
      this.previewType = type;
    });
    return this.previewType;
  }

  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displayLogoContentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
  getLogoUploadImage(selectedDisplayValue, event) {
    this.deviceWallPaperContent = [];
    if (event?.target.checked) {
      this.imgFileName = '';
      this.isDWPOptionSel = true;
      if (selectedDisplayValue === GlobalConstants.MAKE_LOGO_WALPAPER_TEXT) {
        this.checkBtnStrLogo = selectedDisplayValue;
        this.checkBtnDwp = '';
        this.setLivePreview();
      } else if (selectedDisplayValue === GlobalConstants.UPLOAD_IMG_TEXT) {
        this.checkBtnDwp = selectedDisplayValue;
        this.checkBtnStrLogo = '';
        this.imgFileName = '';
        this.isImageTypeErrorDeviceWallppr = false;
        this.isImageSizeErrorDeviceWallppr = false;
        this.isImageTypeError = false;
        this.isImageUploadErrorDeviceWallPaper = false;
          if (this.checkDWPisUseruploaded(this.profileDataSet)) {
             this.getDeviceWallpaperByProfileId();
          }
        this.setLivePreview();
      }
    } else {
      this.isDWPOptionSel = false;
      this.checkBtnStrLogo = '';
      this.checkBtnDwp = '';
      this.deviceWallPaperContent = [];
      this.setLivePreview();
    }
  }
  
  changeColorPicker(value) {
    this.setLivePreview();
  }

  uploadImgDeviceWallPaper(imageInput: any) {
    this.imgDoc = imageInput.files;
    if (this.imgDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(this.imgDoc[0]);
      const file: File = imageInput.files[0];
      this.imgFileName = this.imgDoc[0].name;
      this.imgFileType = this.imgDoc[0].type;
      this.imgFileSize = this.imgDoc[0].size;
      const fileType = this.imgDoc[0].type.split('/')[1];
      if ((file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) && (fileType !== GlobalConstants.CONTENT_TYPE_GIF)) {
        this.isImageSizeErrorDeviceWallppr = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
        this.isImageTypeErrorDeviceWallppr = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
          fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
          fileType !== GlobalConstants.CONTENT_TYPE_GIF;
          if (this.isRemoveEnabled || this.isImgVideoSizeInfoEnabled) {
            this.isImageSizeErrorDeviceWallppr = false;
            this.isimageFormatDeviceWallppr = true;
          } else {
            this.isImageUploadErrorDeviceWallPaper = (this.isImageSizeErrorDeviceWallppr || this.isImageTypeErrorDeviceWallppr);
            this.isimageFormatDeviceWallppr = !this.isImageUploadErrorDeviceWallPaper;
          }
      } else {
        this.isimageFormatDeviceWallppr = false;
        this.isImageUploadErrorDeviceWallPaper = true;
        this.isImageTypeErrorDeviceWallppr = true;
      }
      if (!this.isImageUploadErrorDeviceWallPaper) {
        reader.addEventListener('load', (event: any) => {
          let imageUrl: any = reader.result;
          this.setLivePreview(imageUrl);
          const deviceWallPaper = {
            fileName: this.imgFileName,
          };
          this.storeLogoService.createDeviceWallPaper(JSON.stringify(deviceWallPaper), this.profileDataSet?.profileId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(createDevicWallPaper => {
              const createDeviceWallpaperResponse: CreateDeviceWallpaperResponse = createDevicWallPaper as CreateDeviceWallpaperResponse;
              const deviceWallPaperViewModel: DeviceWallpaperViewModel = createDeviceWallpaperResponse?.deviceWallpaper as DeviceWallpaperViewModel;
              this.storeLogoService.uploadImageDeviceWallPaper(file, createDeviceWallpaperResponse?.deviceWallpaper?.deviceWallpaperId, this.imgFileName)
                .pipe(takeUntil(this.ngUnsubscribe))
                .pipe(first())
                .subscribe(() => {
                  if (!this.otherStoreLogos || (this.otherStoreLogos && this.otherStoreLogos.length === 0)) {
                    this.otherStoreLogos = [];
                  }
                  deviceWallPaperViewModel.imageData = event.target.result;
                  deviceWallPaperViewModel.shortFileName = this.getShortFileName(file.name);
                  deviceWallPaperViewModel.fileName = file.name;
                  // deviceWallPaperViewModel.updatedTime = new Date(deviceWallPaperViewModel.updateTime);
                  deviceWallPaperViewModel.updateTimeDisplay = new Date(deviceWallPaperViewModel.updatedTime).toLocaleString()
                    .replace(',', '');
                  this.deviceWallPaperContent.splice(0, 1, deviceWallPaperViewModel);
                  this.sortBy('uploadDate');

                },

                  error => {
                    // do something
                  });
            },
              error => {
                // do something
              });

        });
      }

    }
  }
setLivePreview(uploadImgURL?: string) {
  this.livePreviewData = [];
  this.livePreviewData.push({
    imageData: (!uploadImgURL) ? this.deviceWallPaperContent[0]?.imageData : uploadImgURL,
    bgColor: this.bgColorSelected,
    isDWPOptionSelected: this.isDWPOptionSel,
    type: GlobalConstants.DEVICE_WALLPAPER_ID
  });
  this.cmnService.emitLivePreviewDataToProfile(this.livePreviewData);
}
}
